// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2rTAE","calendarButtons":"ClockData_calendarButtons__2nR6S"};